export function setNotificationsCallback(callbackId, callback) {
  window.signalRNotificationsCallbacks[callbackId] = callback;
}